import * as React from 'react';
import UserAccountView from '../layouts/UserAccountView';
import { UserAccountData } from 'src/reducers/userAccount';
// import { Snackbar } from '@material-ui/core';
// import { Alert, AlertTitle } from '@material-ui/lab';

export interface UserAccountPageProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  userAccounts: UserAccountData[];

  addAccount: () => void;
  getUserAcc: (username: string) => void;
  editAccount: () => void;
  resetUsers: () => void;
  resetPassword: (username: string) => void;

  addPusername: (pusername: string) => void;
  addNickname: (nickname: string) => void;
  addEmailuser: (emailuser: string) => void;
  addMobileuser: (mobileuser: string) => void;

  pusername: string;
  nickname: string;
  emailuser: string;
  mobileuser: string;

  // errorMessage: string;
  // errorBar: boolean;
  // successMessage: string;
  // successBar: boolean;
  handleClose: () => void;
}

class UserAccount extends React.Component<UserAccountPageProps> {
  render() {
    return (
      <div>
        <UserAccountView
          userAccounts={this.props.userAccounts}
          addAccount={this.props.addAccount}
          getUserAcc={this.props.getUserAcc}
          editAccount={this.props.editAccount}
          resetUsers={this.props.resetUsers}
          addPusername={this.props.addPusername}
          addNickname={this.props.addNickname}
          addEmailuser={this.props.addEmailuser}
          addMobileuser={this.props.addMobileuser}
          pusername={this.props.pusername}
          nickname={this.props.nickname}
          emailuser={this.props.emailuser}
          mobileuser={this.props.mobileuser}
          resetPassword={this.props.resetPassword}
        />
        {/* <------------------------------------------------------Error Message---------------------------------> */}
        {/* <Snackbar
          open={this.props.errorBar}
          autoHideDuration={3000}
          transitionDuration={1000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="error"
            onClose={this.props.handleClose}
          >
            <AlertTitle>Error</AlertTitle>
            {this.props.errorMessage}
          </Alert>
        </Snackbar> */}
        {/* <------------------------------------------------------Success Message---------------------------------> */}
        {/* <Snackbar
          open={this.props.successBar}
          autoHideDuration={3000}
          transitionDuration={1000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="success"
            onClose={this.props.handleClose}
          >
            <AlertTitle>Success</AlertTitle>
            {this.props.successMessage}
          </Alert>
        </Snackbar> */}
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
}

export default UserAccount;



// WEBPACK FOOTER //
// ./src/components/userAccount/UserAccount.tsx